import { render, staticRenderFns } from "./DashboardFaturamento.vue?vue&type=template&id=09e7ec75&scoped=true&"
import script from "./DashboardFaturamento.vue?vue&type=script&lang=js&"
export * from "./DashboardFaturamento.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFaturamento.vue?vue&type=style&index=0&id=09e7ec75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e7ec75",
  null
  
)

export default component.exports